module.exports = __webpack_public_path__ + "static/media/banner3.1b10c93f.jpg";